import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const DataLoading = () => {
  const load = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <div className="justify full-height full-width">
      <Spin indicator={load} />
    </div>
  );
};
